export const bottleListingDict: Record<string, [en: string, th: string]> = {
  "BottleListing.pageTitle": ["Wine Bottles Inventory", "จัดการขวดทั้งหมด"],
  "BottleListing.breadcrumb": ["Bottles", "ขวด"],
  "BottleListing.allBottles": ["All Bottles", "ขวดทั้งหมด"],
  "BottleListing.subtitle": [
    "Search and manage bottles across all receipts by QR Code or RFID UUID",
    "ค้นหาและจัดการขวดทุกใบรับ ด้วย QR Code หรือ RFID UUID",
  ],
  "BottleListing.statusGuide": ["Status Guide", "คู่มือสถานะ"],
  "BottleListing.statusGuideTitle": ["Bottle status guide", "คู่มือสถานะขวด"],
  "BottleListing.searchPlaceholder": ["Search by QR code or RFID UUID...", "ค้นหาด้วย QR code หรือ RFID UUID..."],
  "BottleListing.allWines": ["All Wines", "ไวน์ทั้งหมด"],
  "BottleListing.allLocations": ["All Locations", "ตำแหน่งทั้งหมด"],
  "BottleListing.allReceiptItems": ["All Receipts", "ใบรับทั้งหมด"],
  "BottleListing.rfidTag": ["RFID Tag", "RFID Tag"],
  "BottleListing.tagged": ["Tagged", "มี RFID"],
  "BottleListing.noRfid": ["No RFID", "ไม่มี RFID"],
  "BottleListing.audit": ["Audit", "Audit"],
  "BottleListing.audited": ["Audited", "ตรวจแล้ว"],
  "BottleListing.neverAudited": ["Never audited", "ยังไม่เคยตรวจ"],
  "BottleListing.checkoutAge": ["Checkout Age", "อายุ Checkout"],
  "BottleListing.addStock": ["Add Stock", "เพิ่มสต็อก"],
  "BottleListing.groupByWine": ["Group bottles by wine", "จัดกลุ่มขวดตามไวน์"],
  "BottleListing.refreshData": ["Refresh data", "รีเฟรชข้อมูล"],
  "BottleListing.empty": ["No bottles found. Try a different search or filter.", "ไม่พบขวด ลองค้นหาหรือเปลี่ยนตัวกรอง"],
  "BottleListing.filterByReceipt": ["Filter by this receipt", "กรองด้วยเลขใบรับนี้"],
  "BottleListing.checkedOutAt": ["Checked out at {date}", "Checkout เมื่อ {date}"],
  "BottleListing.returnToStock": ["Return to Stock", "คืนเข้าสต็อก"],
  "BottleListing.return": ["Return", "คืน"],
  "BottleListing.history": ["History", "ประวัติ"],
  "BottleListing.editTitle": ["Edit Bottle Details", "แก้ไขรายละเอียดขวด"],
  "BottleListing.totalBottles": ["Total {total} bottles", "ทั้งหมด {total} ขวด"],
  "BottleListing.showingBottles": ["Showing {shown} of {total} bottles", "แสดง {shown} จาก {total} ขวด"],
  "BottleListing.selected": ["{count} bottle(s) selected", "เลือก {count} ขวด"],
  "BottleListing.print": ["Print", "พิมพ์"],
  "BottleListing.moveCount": ["Move ({count})", "ย้าย ({count})"],
  "BottleListing.updateStatusCount": ["Update Status ({count})", "อัปเดตสถานะ ({count})"],
  "BottleListing.checkoutCount": ["Checkout ({count})", "Checkout ({count})"],
  "BottleListing.closeCheckoutCount": ["Close Checkout ({count})", "ปิด Checkout ({count})"],
  "BottleListing.auditCount": ["Audit ({count})", "Audit ({count})"],
  "BottleListing.generateRfidCount": ["Generate RFID ({count})", "สร้าง RFID ({count})"],
  "BottleListing.restoreCount": ["Restore ({count})", "คืนสต็อก ({count})"],
  "BottleListing.restoreTooltip": ["Restore sold/voided bottles back to in_stock", "คืนขวดที่ขายแล้ว/ยกเลิกแล้วกลับเป็น in_stock"],
  "BottleListing.restoreTitle": ["Restore to In-Stock", "คืนเข้าสต็อก"],
  "BottleListing.restoreReason": ["Restore reason (required)", "เหตุผลการคืนสต็อก (จำเป็น)"],
  "BottleListing.restoreReasonPlaceholder": ["Reason for restoring to in_stock...", "เหตุผลในการคืนสถานะเป็น in_stock..."],
  "BottleListing.applyRestore": ["Restore to In-Stock", "คืนเข้าสต็อก"],
  "BottleListing.restoreSuccess": ["Restored {count} bottle(s) to in_stock", "คืน {count} ขวดเป็น in_stock สำเร็จ"],
  "BottleListing.restoreFailed": ["Failed to restore bottles", "คืนสต็อกไม่สำเร็จ"],
  "BottleListing.restoreSkipped": ["{count} selected bottle(s) are not sold/voided and will be skipped.", "{count} ขวดที่เลือกไม่ได้อยู่ในสถานะ sold/voided และจะถูกข้าม"],
  "BottleListing.generateRfidTooltip": ["Generate random RFID tags for bottles without RFID", "สร้าง RFID Tag สำหรับขวดที่ยังไม่มี RFID"],
  "BottleListing.checkoutTooltip": ["Authorize in-stock bottles to leave through the RFID gate", "อนุญาตนำขวดในสต็อกออกผ่าน RFID Gate"],
  "BottleListing.closeCheckoutTooltip": ["Close active checkouts and choose the final result", "ปิด checkout ที่ยัง active และเลือกผลลัพธ์สุดท้าย"],
  "BottleListing.clearSelection": ["Clear selection", "ล้างรายการที่เลือก"],
  "BottleListing.destination": ["Destination", "ปลายทาง"],
  "BottleListing.skippedNotInStock": ["{count} selected bottle(s) are not in_stock and will be skipped.", "{count} ขวดที่เลือกไม่ได้อยู่ในสถานะ in_stock และจะถูกข้าม"],
  "BottleListing.skippedNotCheckedOut": ["{count} selected bottle(s) are not checked_out and will be skipped.", "{count} ขวดที่เลือกไม่ได้อยู่ในสถานะ checked_out และจะถูกข้าม"],
  "BottleListing.selectLocation": ["Select location...", "เลือกตำแหน่ง..."],
  "BottleListing.notes": ["Notes", "หมายเหตุ"],
  "BottleListing.notesOptional": ["Notes (optional)", "หมายเหตุ (ถ้ามี)"],
  "BottleListing.optionalNotes": ["Optional notes...", "หมายเหตุเพิ่มเติม..."],
  "BottleListing.applyMove": ["Apply Move", "ยืนยันการย้าย"],
  "BottleListing.updateStatus": ["Update status", "อัปเดตสถานะ"],
  "BottleListing.selectStatus": ["Select status...", "เลือกสถานะ..."],
  "BottleListing.reasonRequired": ["Reason (required)", "เหตุผล (จำเป็น)"],
  "BottleListing.statusReasonPlaceholder": ["Reason for status update...", "เหตุผลในการอัปเดตสถานะ..."],
  "BottleListing.applyStatus": ["Apply Status", "ยืนยันสถานะ"],
  "BottleListing.checkoutReason": ["Checkout reason", "เหตุผล Checkout"],
  "BottleListing.checkoutReasonHelp": ["Authorize bottle removal", "อนุญาตนำขวดออก"],
  "BottleListing.checkout": ["Checkout", "Checkout"],
  "BottleListing.closeCheckedOutAs": ["Close checked-out bottles as", "ปิดขวดที่ checkout เป็น"],
  "BottleListing.closeCheckout": ["Close Checkout", "ปิด Checkout"],
  "BottleListing.auditScope": ["Audit Scope", "ขอบเขต Audit"],
  "BottleListing.selectLocationFirst": ["Select Location Filter First", "เลือก Location Filter ก่อน"],
  "BottleListing.submitAudit": ["Submit Audit", "ส่งผล Audit"],
  "BottleListing.generateRfidTitle": ["Generate RFID Tags", "สร้าง RFID Tag"],
  "BottleListing.generateRfidDesc": ["Generate random RFID tags for selected bottles without RFID. Existing RFID tags will not be replaced.", "สร้าง RFID Tag แบบสุ่มสำหรับขวดที่เลือก ขวดที่มี RFID แล้วจะไม่ถูกแทนที่"],
  "BottleListing.skippedHaveRfid": ["{count} selected bottle(s) already have RFID and will be skipped.", "{count} ขวดที่เลือกมี RFID อยู่แล้วและจะถูกข้าม"],
  "BottleListing.applyGenerateRfid": ["Generate RFID", "สร้าง RFID"],
  "BottleListing.generateRfidSuccess": ["Successfully generated RFID for {count} bottle(s)", "สร้าง RFID สำเร็จแล้ว {count} ขวด"],
  "BottleListing.generateRfidFailed": ["Failed to generate RFID", "สร้าง RFID ไม่สำเร็จ"],
  "BottleListing.actions": ["Actions", "จัดการ"],
  "BottleListing.column.qr": ["QR", "QR"],
  "BottleListing.column.qrCode": ["QR Code", "QR Code"],
  "BottleListing.column.assetNo": ["Asset No.", "Asset No."],
  "BottleListing.column.rfidNo": ["RFID No.", "RFID No."],
  "BottleListing.column.receiptRef": ["Receipt Ref", "เลขใบรับ"],
  "BottleListing.column.receiptNo": ["Receipt No.", "เลขที่ใบรับ"],
  "BottleListing.column.wine": ["Wine", "ไวน์"],
  "BottleListing.column.wineName": ["Wine Name", "ชื่อไวน์"],
  "BottleListing.column.vintage": ["Vintage", "ปี"],
  "BottleListing.column.category": ["Category", "หมวดหมู่"],
  "BottleListing.column.wineCategory": ["Wine Category", "หมวดหมู่ไวน์"],
  "BottleListing.column.producer": ["Producer", "ผู้ผลิต"],
  "BottleListing.column.country": ["Country", "ประเทศ"],
  "BottleListing.column.price": ["Price", "ราคา"],
  "BottleListing.column.sellPrice": ["Sell Price", "ราคาขาย"],
  "BottleListing.column.purchasePrice": ["Purchase Price", "ราคาซื้อ"],
  "BottleListing.column.purchaseDate": ["Purchase Date", "วันที่ซื้อ"],
  "BottleListing.column.location": ["Location", "ตำแหน่ง"],
  "BottleListing.column.status": ["Status", "สถานะ"],
  "BottleListing.column.checkedOutFor": ["Checked Out For", "Checkout มาแล้ว"],
  "BottleListing.column.lastAuditBy": ["Last Audit By", "ตรวจล่าสุดโดย"],
  "BottleListing.column.auditStatus": ["Audit Status", "สถานะ Audit"],
  "BottleListing.column.auditTime": ["Audit Time", "เวลา Audit"],
  "BottleListing.column.lastUpdate": ["Last Update", "อัปเดตล่าสุด"],
  "BottleListing.checkoutAgeOption.4h": ["4+ hours", "4+ ชั่วโมง"],
  "BottleListing.checkoutAgeOption.6h": ["6+ hours", "6+ ชั่วโมง"],
  "BottleListing.checkoutAgeOption.12h": ["12+ hours", "12+ ชั่วโมง"],
  "BottleListing.checkoutAgeOption.1d": ["1+ day", "1+ วัน"],
  "BottleListing.reason.service": ["Service", "Service"],
  "BottleListing.reason.tasting": ["Tasting", "Tasting"],
  "BottleListing.reason.event": ["Event", "Event"],
  "BottleListing.reason.transfer": ["Transfer", "Transfer"],
  "BottleListing.reason.damaged": ["Damaged", "เสียหาย"],
  "BottleListing.reason.other": ["Other", "อื่น ๆ"],
  "BottleListing.result.inStock": ["Return to Stock", "คืนเข้าสต็อก"],
  "BottleListing.result.sold": ["Sold", "ขายแล้ว"],
  "BottleListing.result.lost": ["Lost", "สูญหาย"],
  "BottleListing.result.unsellable": ["Unsellable", "ขายไม่ได้"],
  "BottleListing.uncategorized": ["Uncategorized", "ไม่ระบุหมวดหมู่"],
  "BottleListing.unknown": ["(Unknown)", "(ไม่ทราบ)"],
  "BottleListing.loadFailed": ["Failed to load bottles", "โหลดรายการขวดไม่สำเร็จ"],
  "BottleListing.loadLocationsFailed": ["Failed to load locations", "โหลดตำแหน่งไม่สำเร็จ"],

  // ── BottleEditDialog ─────────────────────────────────────
  "BottleEditDialog.editTitle": ["Edit Bottle", "แก้ไขขวด"],
  "BottleEditDialog.bottleLabel": ["Bottle", "ขวด"],
  "BottleEditDialog.rfidNo": ["RFID No.", "RFID No."],
  "BottleEditDialog.status": ["Status", "สถานะ"],
  "BottleEditDialog.notes": ["Notes", "หมายเหตุ"],
  "BottleEditDialog.reason": ["Reason", "เหตุผล"],
  "BottleEditDialog.reasonRecovery": ["Recovery reason", "เหตุผลการคืน"],
  "BottleEditDialog.reasonCheckout": ["Checkout reason", "เหตุผล Checkout"],
  "BottleEditDialog.reasonCloseCheckout": ["Close checkout reason", "เหตุผลปิด Checkout"],

  // ── BottleGroupByWineDialog ──────────────────────────────
  "BottleGroupByWineDialog.title": ["Bottles by Wine", "จัดกลุ่มขวดตามไวน์"],

  // ── BottleHistoryDialog ──────────────────────────────────
  "BottleHistoryDialog.title": ["Bottle History", "ประวัติขวด"],
  "BottleHistoryDialog.tab.checkoutTimeline": ["Checkout Timeline", "ไทม์ไลน์ Checkout"],
  "BottleHistoryDialog.tab.auditHistory": ["Audit History", "ประวัติการตรวจนับ"],
  "BottleHistoryDialog.tab.activityLog": ["Activity Log", "บันทึกกิจกรรม"],
  "BottleHistoryDialog.column.date": ["Date", "วันที่"],
  "BottleHistoryDialog.column.auditor": ["Auditor", "ผู้ตรวจ"],
  "BottleHistoryDialog.column.method": ["Method", "วิธี"],
  "BottleHistoryDialog.column.status": ["Status", "สถานะ"],
  "BottleHistoryDialog.column.user": ["User", "ผู้ใช้"],
  "BottleHistoryDialog.column.action": ["Action", "การกระทำ"],
  "BottleHistoryDialog.column.details": ["Details", "รายละเอียด"],
};
